// setLayoutProperties sets layout properties for a form element 
// when it gets dropped into a container
export const setLayoutProperties = (container: any, item: any) => {
  if (item.properties.layout) {
    item.properties.layout.parent =
      container.properties.layout && container.properties.layout.direction;
  } else {
    item.properties["layout"] = {
      parent:
        container.properties.layout && container.properties.layout.direction,
    };
  }

  // for some components, default layout properties needs to be
  // given. Otherwise, they will not display properly
  if (item.type === "Image" || item.type === "ImageViewer") {
    item.properties.layout = {
      ...item.properties.layout,
      heightMode: "px",
      widthMode: "px",
      height: "100",
      width: "100",
    };
  }

  if (item.type === "Divider") {
    item.properties.layout = {
      ...item.properties.layout,
      widthMode: "fill",
    };
  }

  if (item.type === "Section") {
    item.properties.layout = {
      ...item.properties.layout,
      widthMode: "fill",
    };
  }
};
